import { render, staticRenderFns } from "./userFeeManger.vue?vue&type=template&id=c8ed8652&"
import script from "./userFeeManger.vue?vue&type=script&lang=js&"
export * from "./userFeeManger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports